var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TimeUtils from '@business/utils/time';
import CartTotals from '@data/models/CartTotals';
import { isVariableChargeType } from '@data/models/ChargeType';
import { isAllotmentBlockCode } from '@business/utils/promocodes';
import Store from '@data/stores/Store';
import { apiCall } from '../axios';
export class CartService {
    static calculate(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accommodations, addons = [], checkIn, checkOut, code, currency, externalOffers = [], propertyId, lang = 'en', }) {
            // loop throw all the accommodations and create an object to send to the api
            const rates = [];
            for (let i = 0; i < accommodations.length; i++) {
                const accommodation = accommodations[i];
                const accommodationAddons = this.findAddonsOfAccommodation(accommodation, addons);
                for (let j = 0; j < accommodation.quantity; j++) {
                    const rate = {
                        addons: [],
                        adults: accommodation.adults,
                        kids: accommodation.kids,
                        rateId: accommodation.rateId,
                    };
                    accommodationAddons.forEach((addon) => {
                        var _a;
                        const variable = isVariableChargeType(addon);
                        // non-variable addons (fixed charge types and the 'quantity' type)
                        // are sent once, on the first room only
                        if (!variable && j > 0) {
                            return;
                        }
                        (_a = rate.addons) === null || _a === void 0 ? void 0 : _a.push({
                            addon_id: addon.addonId,
                            // Mirror the prepare/makeReservation payload (groupAddons in
                            // business-layer/utils/reservation.ts): variable charge types are
                            // sent as quantity:1 duplicated once per room (this loop is the
                            // per-room duplication), letting the backend apply the guest/night
                            // multipliers. addon.quantity is already room-pre-multiplied in the
                            // cart store (Cart.getAmountMultiplierForAddon), so reusing it here
                            // applies the room factor twice and inflates the subtotal/grandTotal
                            // (BENG-2917). Non-variable types keep their literal quantity.
                            quantity: variable ? 1 : addon.quantity,
                        });
                    });
                    rates.push(rate);
                }
            }
            const body = {};
            body.lang = lang;
            body['data[checkIn]'] = TimeUtils.format(checkIn);
            body['data[checkOut]'] = TimeUtils.format(checkOut);
            body['data[currency]'] = (currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) || 'USD';
            body['data[rates]'] = JSON.stringify(rates);
            body['property_id'] = propertyId;
            if (code && isAllotmentBlockCode(code)) {
                body['data[allotmentBlockCode]'] = code;
            }
            else if (code) {
                body['data[promo]'] = code;
            }
            if (externalOffers.length > 0) {
                body['data[externalOffers]'] = JSON.stringify(externalOffers);
            }
            const totals = yield apiCall(CartTotals)('post', '/calculateTotals', body);
            Store.session.setCartToken(totals.cart_token);
            return totals;
        });
    }
    static updateTotals(_a) {
        return __awaiter(this, arguments, void 0, function* ({ addons, propertyId, cartItems, data_res, lang = 'en', }) {
            const body = {};
            body.lang = lang;
            let index = 0;
            addons.forEach((addon) => {
                var _a;
                const accommodation = [...cartItems].find((x) => { var _a; return (_a = x.model) === null || _a === void 0 ? void 0 : _a.item.bookedId.includes(addon.accommodationBookedId); });
                const bookedId = ((_a = accommodation === null || accommodation === void 0 ? void 0 : accommodation.model) === null || _a === void 0 ? void 0 : _a.item.bookedId) || [];
                for (let i = 0; i < bookedId.length; i++) {
                    body[`addons[${index}][addon_id]`] = addon.addonId;
                    body[`addons[${index}][quantity]`] = addon.quantity;
                    body[`addons[${index}][booking_room_id]`] = bookedId[i];
                    index++;
                }
            });
            body['property_id'] = propertyId;
            return yield apiCall(CartTotals)('post', `/update_total?data_res=${data_res}`, body);
        });
    }
}
Object.defineProperty(CartService, "findAddonsOfAccommodation", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (accommodation, addons) => addons.filter((addon) => addon.accommodationId === accommodation.roomId &&
        addon.accommodationPackageId === accommodation.packageId &&
        addon.accommodationAdults === accommodation.adults &&
        addon.accommodationKids === accommodation.kids)
});
